import { GpsFixIcon, MapWithMarker, Mtds } from 'prove-common'
import { ManualLocationRegistrationModal } from 'prove-common'
import { useState } from 'react'

type NotAccurateLocationProps = {
  position: GeolocationPosition
  sampleId?: string
  requiredAccuracy: number
  newSample?: boolean
  onSelectedLonLatChanged?: (lonLat: [number, number]) => void
}

export const NotAccurateLocation = ({
  position,
  sampleId,
  requiredAccuracy,
  newSample,
  onSelectedLonLatChanged
}: NotAccurateLocationProps) => {
  const [isManualModalOpen, setIsManualModalOpen] = useState(false)
  return (
    <Mtds.Card
      as={Mtds.Grid}
      data-gap={8}
      data-color={'warning'}
      className='bg-surface-tinted'
    >
      <Mtds.Info>
        <GpsFixIcon />
        <strong>Unøyaktig posisjon</strong> Oppgaven krever mer nøyaktig
        posisjon
      </Mtds.Info>
      <MapWithMarker
        latitude={position.coords.latitude}
        longitude={position.coords.longitude}
      />
      <Mtds.Table data-fixed>
        <tbody>
          <tr>
            <td>Nøyaktighet</td>
            <td>&nbsp;&nbsp;{Math.floor(position.coords.accuracy)}m</td>
          </tr>
          <tr>
            <td>Krav til nøyaktighet</td>
            <td>&gt; {requiredAccuracy}m</td>
          </tr>
        </tbody>
      </Mtds.Table>
      <Mtds.Button
        data-variant={'secondary'}
        onClick={() => {
          setIsManualModalOpen(true)
        }}
      >
        Legg til posisjon manuelt
      </Mtds.Button>
      {isManualModalOpen && (
        <ManualLocationRegistrationModal
          isManualModalOpen={isManualModalOpen}
          setIsManualModalOpen={setIsManualModalOpen}
          sampleId={sampleId}
          newSample={newSample}
          position={position}
          onSelectedLonLatChanged={onSelectedLonLatChanged}
        />
      )}
    </Mtds.Card>
  )
}
